import React, { Component, ReactNode } from "react";
import styled from "styled-components";

const MaxHeightContainer = styled.div`
  height: 100vh;
`;

class MainLayout extends Component<{}, {}> {
  public componentDidUpdate(): void {
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }

  public render(): ReactNode {
    const { children } = this.props;
    return (
      <MaxHeightContainer>
        <div className="main-content">{children}</div>
      </MaxHeightContainer>
    );
  }
}

export default MainLayout;
